import { render } from "./bloc.vue?vue&type=template&id=28699b2e&scoped=true"
import script from "./bloc.vue?vue&type=script&lang=js"
export * from "./bloc.vue?vue&type=script&lang=js"

import "./bloc.vue?vue&type=style&index=0&id=28699b2e&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28699b2e"]])

export default __exports__